module.exports = {
	"usa-nhl": "844991",
	"usa": "844991",
	"england-premier-league": "844714",
	"khl": "845527",
	"spain-liga-bbva": "845513",
	"spanien-liga-bbva": "845513",
	"italy-serie-a": "845699",
	"italien-serie-a": "845699",
	"danmark-superligaen": "844593",
	"frankrig-ligue-1": "844562",
	"france-ligue-1": "844562",
	"danmark-metal-ligaen": "845192"
};


//////////////////
// WEBPACK FOOTER
// ./src/config/competitionToStageMapping.json
// module id = 1044
// module chunks = 1 2